export default __webpack_public_path__ + "static/EverydayRecognitionRewards4-3a849c7fcab1d41571ee305b9907770c.png";